export enum Application {
    BELLA = 'bella',
}

export interface DataLayer {
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
    'app.name': Application;
    categories_path?: string;
    category_id?: number;
    is_bella_user: boolean;
    'category-productcode_3SKU_json'?: string[];
    pageType: string;
    page_number?: number;
    platform: string;
    skus?: string;
    /* eslint-enable @typescript-eslint/camelcase, camelcase */
}

export default {};
